import React, { Component, Fragment } from 'react'
import PropTypes from "prop-types"

class CustomerInfo extends Component {
  static propTypes = {
    data: PropTypes.object
  }
  
  static defaultProps = {
    data: {}
  }

  constructor(props) {
    super(props);
    this.state = {
      header_npwp: ''
    }
  }

  handleChangeNIK = (e) => {
    let value = e.target.value
    this.props.onChangeNPWP(value)
    this.setState({ header_npwp: value})
  }

  render() {
    return (
      <Fragment>
        <div className="card">
          <div className="card-header bg-light font-weight-bold">
            <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#collapse-customer-info" role="button" aria-expanded="false" aria-controls="collapse-customer-info">Customer Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
          </div>
          <div className="multi-collapse show" id="collapse-customer-info">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                      Customer
                    </label>
                    <div className="col-sm-8">
                      <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="customer_name" placeholder="" value={this.props.data.customer_name} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                      NPWP Name
                    </label>
                    <div className="col-sm-8">
                      <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="customer_npwp_name" placeholder="" value={this.props.data.header_npwp_name} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                      NPWP / NIK
                    </label>
                    <div className="col-sm-8">
                      <input type="text" autoComplete="off" disabled={this.props.is_edit ? false : true } className="form-control" id="inputEmail3" name="customer_npwp_no" placeholder="" value={this.props.data.header_npwp ? this.props.data.header_npwp : this.state.header_npwp} onChange={ this.handleChangeNIK.bind(this)} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                      NPWP Address
                    </label>
                    <div className="col-sm-8">
                      <textarea autoComplete="off" disabled className="form-control" id="inputEmail3" name="customer_npwp_address" placeholder="" rows={5} cols={3} value={this.props.data.header_npwp_address} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default CustomerInfo